import { useNextTranslation } from "../../hooks";
import { ProductBookNowButton, ProductBookNowButtonProps } from "../../product/ProductBookNowButton";
import type { ExternalWidgetPeek as ExternalWidgetPeekType } from "../../types/ExternalWidget";

export type ExternalWidgetPeekProps = Omit<ExternalWidgetPeekType, "__typename"> & {
    ButtonComponent?: (props: ProductBookNowButtonProps) => JSX.Element;
};

export function ExternalWidgetPeek({ keyId, widgetId, ButtonComponent }: ExternalWidgetPeekProps) {
    const [t] = useNextTranslation("externalWidget");
    const Button = ButtonComponent ?? ProductBookNowButton;

    Object.assign(window, {
        _peekConfig: { key: keyId },
    });

    const href = `https://www.peek.com/s/${keyId}/${widgetId}`;
    return (
        <>
            <Button href={href} data-button-text="Book Now">
                {t("peek.availabilityButton.label")}
            </Button>
        </>
    );
}
